import router from "./router";
import store from './store'

router.beforeEach((to, from, next) => {
    if (to.meta.title != '表单') {
        document.title = to.meta.title
    } 
    // if (store.state.UserMeterList === null || store.state.UserMeterList.length == 0) {
    //     store.dispatch("getUserMeterList")
    // }
    next();
});